// key buildId 对应的楼层
export const updateTextBuildId = {
  // 长坦市人民医院
  '1666627374474407937': 2,
  // 成都市第一人民医院
  '1852195466537275394': 1
}
// 要隐藏的文字FID
export const textJson = {
  //长坦市人民医院
  '7072136711140151296': true,
  '7072136930284146688': true,
  '7072177740820123648': true,
  '7072881686693941248': true,
  //成都市第一人民医院
  '7256496351477895168': true,
  '7256496576166760448': true,
  '7256497443439775744': true,
  '7256502875520634880': true,
  '7256504024965451776': true,
  '7256504921208524800': true,
  '7256504254133833728': true,
  '7256505237924614144': true,
  '7256500602526633984': true,
  '7256496890043305984': true,
  '7256509246005710848': true,
  '7256509048974086144': true,
}
// 要添加的文字
export const addTextJson = {
  // 长坦市人民医院
  '1666627374474407937': [
    {
      x: 12766116.30283426,
      y: 4191898.3636491103,
      text: '慢病管理中心'
    }
  ],
  // 成都市第一人民医院
  '1852195466537275394': [
    {
      x: 11583032.558,
      y: 3579740.94,
      text: 'B516'
    },
    {
      x: 11583028.636,
      y: 3579740.886,
      text: '换药室-B515'
    },
    {
      x: 11583020.773,
      y: 3579739.02,
      text: '肛肠科专科门诊-B514'
    },
    {
      x: 11583016.724,
      y: 3579740.904,
      text: '肛肠科专科门诊-B513'
    },
    {
      x: 11583008.932,
      y: 3579743.419,
      text: '肝胆胰脾外科专科门诊-B508'
    },
    {
      x: 11583009.834,
      y: 3579747.758,
      text: '骨质疏松专病门诊-B507'
    },
    {
      x: 11583016.579,
      y: 3579748.602,
      text: '胃肠疝专科门诊-B509'
    },
    {
      x: 11583020.579,
      y: 3579747.08,
      text: '肾脏内科专科门诊-B510'
    },
    {
      x: 11583029.537,
      y: 3579747.533,
      text: '运动医学与关节镜门诊-B511'
    },
    {
      x: 11583032.453,
      y: 3579750.869,
      text: 'B505'
    },
    {
      x: 11583028.507,
      y: 3579752.57,
      text: '卫生间'
    },
    {
      x: 11583020.749,
      y: 3579751.446,
      text: '脊柱外科门诊-B503'
    },
    {
      x: 11583016.75,
      y: 3579752.721,
      text: '骨创伤/骨病外科门诊-B502'
    },
    {
      x: 11583008.804,
      y: 3579752.059,
      text: '关节外科门诊-B501'
    },
    {
      x: 11583004.836,
      y: 3579755.823,
      text: '咨询台'
    },
    {
      x: 11583038.581,
      y: 3579754.264,
      text: '采血处'
    },
    {
      x: 11583042.323,
      y: 3579752.697,
      text: 'B506'
    },
    {
      x: 11583008.886,
      y: 3579738.482,
      text: '卫生间'
    },
    {
      x: 11583004.893,
      y: 3579750.832,
      text: '挂号处'
    }
  ]
} 
